export default __webpack_public_path__ + "static/media/satish-chitre.f1491439.jpg";